"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var react_1 = require("@emotion/react");
var react_2 = require("react");
var recoil_1 = require("recoil");
var Styled = __importStar(require("./ActivityScoreModalDialog.styled"));
var ActivityScore_1 = require("@/components/ActivityScore");
var store_1 = require("@/store");
var utils_1 = require("@/utils");
var api = __importStar(require("@/api"));
var hooks_1 = require("@/hooks");
var styles_1 = require("@/styles");
var member_1 = require("@/store/member");
var ActivityScoreModalDialog = function (_a) {
    var scoreHistory = _a.scoreHistory, generationNumber = _a.generationNumber, memberId = _a.memberId;
    var scoreHistoryId = scoreHistory.scoreHistoryId, scoreType = scoreHistory.scoreType, scoreName = scoreHistory.scoreName, scheduleName = scoreHistory.scheduleName, memo = scoreHistory.memo, accumulatedScore = scoreHistory.accumulatedScore, score = scoreHistory.score, isCanceled = scoreHistory.isCanceled, date = scoreHistory.date;
    var _b = __read((0, react_2.useState)(false), 2), isLoading = _b[0], setIsLoading = _b[1];
    var handleAddToast = (0, hooks_1.useToast)().handleAddToast;
    var handleActivityScoreModal = (0, recoil_1.useSetRecoilState)((0, store_1.$modalByStorage)(store_1.ModalKey.activityScoreModalDialog));
    var handleCloseModal = function () {
        return handleActivityScoreModal({ key: store_1.ModalKey.activityScoreModalDialog, isOpen: false });
    };
    var handleRemoveCurrentModal = (0, recoil_1.useRecoilCallback)(function (_a) {
        var set = _a.set;
        return function () {
            set((0, store_1.$modalByStorage)(store_1.ModalKey.activityScoreModalDialog), {
                key: store_1.ModalKey.alertModalDialog,
                isOpen: false,
            });
            set((0, store_1.$modalByStorage)(store_1.ModalKey.alertModalDialog), {
                key: store_1.ModalKey.alertModalDialog,
                isOpen: false,
            });
        };
    });
    var handleCancelActivityScore = (0, recoil_1.useRecoilCallback)(function (_a) {
        var set = _a.set, refresh = _a.refresh;
        return function () { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                set((0, store_1.$modalByStorage)(store_1.ModalKey.alertModalDialog), {
                    key: store_1.ModalKey.alertModalDialog,
                    isOpen: true,
                    props: {
                        heading: '점수를 취소하시겠습니까?',
                        confirmButtonLabel: '적용',
                        cancelButtonLabel: '닫기',
                        handleClickConfirmButton: function () {
                            (0, utils_1.request)({
                                requestFunc: function () { return __awaiter(void 0, void 0, void 0, function () {
                                    return __generator(this, function (_a) {
                                        switch (_a.label) {
                                            case 0:
                                                setIsLoading(true);
                                                return [4 /*yield*/, api.postScoreHistoryCancel({ scoreHistoryId: scoreHistoryId, memo: '' })];
                                            case 1:
                                                _a.sent();
                                                return [2 /*return*/];
                                        }
                                    });
                                }); },
                                errorHandler: handleAddToast,
                                onSuccess: function () {
                                    handleRemoveCurrentModal();
                                    handleAddToast({
                                        type: styles_1.ToastType.success,
                                        message: '점수가 취소되었습니다.',
                                    });
                                    refresh((0, member_1.$memberDetail)({
                                        generationNumber: generationNumber,
                                        memberId: memberId,
                                    }));
                                },
                                onCompleted: function () {
                                    setIsLoading(false);
                                    set((0, store_1.$modalByStorage)(store_1.ModalKey.alertModalDialog), {
                                        key: store_1.ModalKey.alertModalDialog,
                                        isOpen: false,
                                    });
                                },
                            });
                        },
                    },
                });
                return [2 /*return*/];
            });
        }); };
    });
    return ((0, jsx_runtime_1.jsx)(Styled.ActivityScoreModalWrapper, __assign({ heading: "\uD65C\uB3D9\uC810\uC218 \uC0C1\uC138", handleCloseModal: handleCloseModal, footer: {
            confirmButton: {
                label: '점수 취소하기',
                onClick: handleCancelActivityScore,
                isLoading: isLoading,
                disabled: isCanceled,
            },
            position: 'center',
        } }, { children: (0, jsx_runtime_1.jsx)(Styled.ModalInner, { children: (0, jsx_runtime_1.jsxs)(Styled.DetailCard, { children: [(0, jsx_runtime_1.jsx)(ActivityScore_1.Icon, { type: scoreType, size: 64 }, void 0), (0, jsx_runtime_1.jsxs)(Styled.ActivityTitle, { children: [scoreName, isCanceled && (0, jsx_runtime_1.jsx)(Styled.CancelLabel, { children: "\uCDE8\uC18C" }, void 0)] }, void 0), (0, jsx_runtime_1.jsx)(Styled.Divider, {}, void 0), (0, jsx_runtime_1.jsxs)(Styled.Content, { children: [(0, jsx_runtime_1.jsxs)(Styled.Row, { children: [(0, jsx_runtime_1.jsx)(Styled.RowLabel, { children: "\uC138\uBBF8\uB098 \uC815\uBCF4" }, void 0), (0, jsx_runtime_1.jsx)(Styled.RowContent, __assign({ isCanceled: isCanceled }, { children: (0, utils_1.parsePlaceholderWhenEmpty)(scheduleName) }), void 0)] }, void 0), (0, jsx_runtime_1.jsxs)(Styled.Row, { children: [(0, jsx_runtime_1.jsx)(Styled.RowLabel, { children: "\uB4F1\uB85D\uC77C\uC2DC" }, void 0), (0, jsx_runtime_1.jsx)(Styled.RowContent, __assign({ isCanceled: isCanceled }, { children: (0, utils_1.formatDate)(date, 'YYYY년 M월 D일 A h시 m분') }), void 0)] }, void 0), (0, jsx_runtime_1.jsxs)(Styled.Row, { children: [(0, jsx_runtime_1.jsx)(Styled.RowLabel, { children: "\uBA54\uBAA8" }, void 0), (0, jsx_runtime_1.jsx)(Styled.RowContent, __assign({ isCanceled: isCanceled }, { children: (0, utils_1.parsePlaceholderWhenEmpty)(memo) }), void 0)] }, void 0), (0, jsx_runtime_1.jsxs)(Styled.Row, { children: [(0, jsx_runtime_1.jsx)(Styled.RowLabel, { children: "\uC810\uC218" }, void 0), (0, jsx_runtime_1.jsx)(Styled.ScoreRangeType, __assign({ isCanceled: isCanceled, type: (0, ActivityScore_1.getScoreRangeType)(score) }, { children: score }), void 0)] }, void 0), (0, jsx_runtime_1.jsxs)(Styled.Row, { children: [(0, jsx_runtime_1.jsx)(Styled.RowLabel, { children: "\uCD1D \uD65C\uB3D9\uC810\uC218" }, void 0), (0, jsx_runtime_1.jsx)(Styled.RowContent, { children: accumulatedScore }, void 0)] }, void 0)] }, void 0)] }, void 0) }, void 0) }), void 0));
};
exports.default = ActivityScoreModalDialog;
